<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">ID</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">Produto</th>
        <th scope="col" class="border-0 text-center">Preço</th>
        <th scope="col" class="border-0 text-center">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in products" :key="index">
        <td class="td-1">{{ row.code }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-product-edit', params: { productId: row.product.id, page: 1 }}">{{ row.name }}</d-link>
        </td>
        <td class="td-2">{{ row.product.name }}</td>
        <td class="td-2 text-right">
          <span @click.prevent="selectedObject = (selectedObject) ? null : row.id" v-if="selectedObject != row.id">{{ addCurrencyMask(row.price) }}</span>
          <d-input-group prepend="R$" v-else>
              <input-currency
                model-index="price"
                placeholder="R$ 0,00"
                :model="row"
              ></input-currency>
            </d-input-group>
        </td>
        <td class="td-1 text-center">
          <d-button size="sm" class="btn-success" @click.prevent="updatePrice(row)">
            <i class="fas fa-save"></i><span class="d-none d-lg-inline"> Salvar</span>
          </d-button>
        </td>
      </tr>
      <tr v-if="products.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum produto cadastrado.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import CurrencyMask from '_common/mixins/CurrencyMask';
import InputCurrency from '_shared/InputCurrency.vue';
import ProductService from '_services/rest/modules/product';

export default {
  name: 'product-price-table',
  mixins: [CurrencyMask],
  components: {
    InputCurrency,
  },
  props: {
    products: {
      type: Array,
    },
  },
  data() {
    return {
      selectedObject: null,
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    updatePrice(product) {
      ProductService.updatePrice(product)
        .then(() => {
          this.selectedObject = null;
          this.activeAlert({ message: 'Preço atualizado com sucesso', theme: 'success' });
        });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-1 {
    width: 10%;
  }
  &-2 {
    width: 20%;
  }
  &-3 {
    width: 30%;
  }
  &-4 {
    width: 40%;
  }
}
</style>
